export enum ShiftType {
  Unknown = -1,
  Required = 0,
  Master = 1,
  Vacay = 2,
  Agenda = 3,
  Manual = 4,
  VacayAvailable = 5
}
